import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FieldValidationType } from '../../../../sic-lib/enums/FieldValidationType';

const useStyles = makeStyles()((theme: Theme) => ({
    item: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
            '&:hover': {
                backgroundColor: theme.palette.menuListHover.main,
            },
        },
    },
}));

const actions: {
    type: Extract<
        FieldValidationType,
        FieldValidationType.email | FieldValidationType.usMobilePhone
    >;
    icon: any;
    label: string;
}[] = [
    {
        type: FieldValidationType.email,
        icon: EmailIcon,
        label: 'Email',
    },
    {
        type: FieldValidationType.usMobilePhone,
        icon: SmsIcon,
        label: 'SMS',
    },
];

interface Props {
    menuId: string;
    anchorEl: HTMLElement | null;
    selected: FieldValidationType;
    onSelectHandler: React.Dispatch<{ fieldType: FieldValidationType }>;
    onCloseHandler: () => void;
}

export default function MenuSetChannelRaw({
    menuId,
    anchorEl,
    selected,
    onSelectHandler,
    onCloseHandler,
}: Props) {
    const { classes } = useStyles();

    const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
        const { fieldType } = event.currentTarget.dataset;

        if (fieldType) {
            onSelectHandler({ fieldType: +fieldType });
            onCloseHandler();
        }
    };

    return (
        <Menu
            id={menuId}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onCloseHandler}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            {actions.map(act => (
                <MenuItem
                    key={act.type}
                    data-field-type={act.type}
                    onClick={handleSelect}
                    selected={selected === act.type}
                    className={classes.item}
                >
                    <ListItemIcon>{React.createElement(act.icon)}</ListItemIcon>
                    <ListItemText primary={act.label} />
                </MenuItem>
            ))}
        </Menu>
    );
}
